/**
 * User: Shad
 * Date: 8/13/13
 */
"use strict";
var SoaModel = require('bunsen/models/SoaModel.js');
var Shipment = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;
var Clump = require('bunsen/libraries/clump');
var $ = require('dibs-jquery-shim');
root.bunsen = root.bunsen || {};

/**
 * Represents a logistics service 'Shipment'.
 *
 * @class Shipment
 * @extends SoaModel
 */
module.exports = root.bunsen.Shipment = Shipment;

var Notes = require('bunsen/collections/Notes');
var Note = require('bunsen/models/Note');
var Backbone = require('dibs-backbone');
var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var TransactionShipmentQuote = require('./TransactionShipmentQuote');
var Address = require('bunsen/models/Address');
var ShipmentContent = require('./ShipmentContent');
var ShipmentTracking = require('./ShipmentTracking');
var ServiceMethod = require('bunsen/models/logistics/ServiceMethod');
var Anchor = require('bunsen/models/Anchor');
var Period = require('bunsen/models/Period');
var transitionMixin = require('bunsen/models/mixins/ecomm/transitionMixin');
var periodMixin = require('bunsen/models/mixins/periodMixin');
var Party = require('bunsen/models/Party');
var Reviews = require('bunsen/collections/ecomm/Reviews');

//Private Members
var carrierPatterns;

carrierPatterns = {
    UPS: /^(1Z[0-9A-Z]{16}|[0-9A-Z]{12}|T[0-9A-Z]{10}|[0-9A-Z]{9}|MI\d{6}[0-9A-Z]{1,22})$/,
    USPS: /^(94\d{20}|\d3\d{18})$/,
    FEDEX: /^\d{12,22}$/
};

//Static Properties/Methods
_.extend(Shipment, {
    TYPE_LOCAL_PICKUP : 'LOCAL_PICKUP',
    TYPE_EXTERNALLY_ARRANGED : 'EXTERNALLY_ARRANGED',
    TYPE_FIRSTDIBS_FACILITATED : 'FIRSTDIBS_FACILITATED',
    STATUS_NEW: 'NEW',
    STATUS_PENDING: 'PENDING',
    STATUS_READY_FOR_PICKUP: 'READY_FOR_PICKUP',
    STATUS_SHIPPED: 'SHIPPED',
    STATUS_DELIVERED: 'DELIVERED',
    STATUS_REGISTRATION_FAILED: 'REGISTRATION_FAILED',
    getTypes: function () {
        return [
            Shipment.TYPE_LOCAL_PICKUP,
            Shipment.TYPE_EXTERNALLY_ARRANGED,
            Shipment.TYPE_FIRSTDIBS_FACILITATED
        ];
    },
    getCarrierPatternFor: function (carrierName) {
        return carrierPatterns[carrierName];
    }
});

_.extend(Shipment.prototype, {
    idAttribute: "id",
    url : function () {
        return endpoints.shipment(this.get(this.idAttribute));
    },
    defaults: {
        notes: [],
        reviews: [],
        shippingAddress: {},
        shipmentTracking: {}
    },
    anchorType: Anchor.TYPE_SHIPMENT,
    relations: function () {
        return SoaModel.createRelations([
            {
                type: Backbone.One,
                key: 'acceptedQuote',
                relatedModel: TransactionShipmentQuote
//                saveJSONFields : ['id']
            },
            {
                type: Backbone.One,
                key: 'shippingAddress',
                relatedModel: Address
            },
            {
                type : Backbone.Many,
                key : 'notes',
                collectionType: Notes,
                omitFromSave: true
            },
            {
                type : Backbone.One,
                key : 'shipmentContent',
                relatedModel : ShipmentContent
            },
            {
                type : Backbone.One,
                key : 'shipmentTracking',
                relatedModel : ShipmentTracking
            },
            {
                type : Backbone.One,
                key : 'transaction',
                relatedModel : SoaModel,
                saveJSONFields: ['id']
            },
            {
                type : Backbone.One,
                key : 'serviceMethod',
                relatedModel : ServiceMethod
            },
            {
                type : Backbone.One,
                key : 'handlingTime',
                relatedModel : Period
            },
            {
                type : Backbone.Many,
                key : 'reviews',
                collectionType: Reviews
            }
        ]);
    },

    getShippingRequestReview: function () {
        return this.get('reviews').getShippingRequest();
    },

    getShippingRequestReviewNote: function () {
        var review =  this.getShippingRequestReview();
        if (review) {
            return review.getShippingRequestNote();
        }
    },

    getShippingRequestReviewNoteContent: function () {
        var note =  this.getShippingRequestReviewNote();
        if (note) {
            return note.get('content');
        }
    },

    /**
     * @returns {number}
     */
    getHandlingTimeDays : function () {
        return this.getPeriodInDays('handlingTime');
    },
    /**
     * @returns {string}
     */
    getDisplayHandlingTimeDays: function () {
        return this.getPeriodDisplayVal('handlingTime');
    },
    /**
     * @returns {string}
     */
    getAddresseeDisplayName: function () {
        var address = this.get('shippingAddress');
        return address ? (address.get('firstName') + ' ' + address.get('lastName')) : null;
    },
    /**
     * @returns {string}
     */
    getLastNote: function () {
        var notes = this.get('notes');
        return notes ? notes.last() : null;
    },
    /**
     * @returns {boolean}
     */
    is1stdibsFacilitated: function () {
        return this.get('shipmentType') === Shipment.TYPE_FIRSTDIBS_FACILITATED;
    },
    /**
     * @returns {Boolean}
     */
    isBuyerArrangedShipping: function () {
        var buyerArrangedShipmentTypes = [Shipment.TYPE_LOCAL_PICKUP, Shipment.TYPE_EXTERNALLY_ARRANGED];
        return _.contains(buyerArrangedShipmentTypes, this.get('shipmentType'));
    },
    /**
     * @returns {Boolean}
     */
    hasNotShipped: function () {
        var preShippedStatuses = [Shipment.STATUS_NEW, Shipment.STATUS_PENDING, Shipment.STATUS_READY_FOR_PICKUP];
        return _.contains(preShippedStatuses, this.get('status'));
    },
    /**
     * @returns {boolean}
     */
    isLocalPickup: function () {
        return this.get('shipmentType') === Shipment.TYPE_LOCAL_PICKUP;
    },
    /**
     * @returns {boolean}
     */
    isExternallyArranged: function () {
        return this.get('shipmentType') === Shipment.TYPE_EXTERNALLY_ARRANGED;
    },
    /**
     * @returns {boolean}
     */
    isStatusNew: function () {
        return this.get('status') === Shipment.STATUS_NEW;
    },
    /**
     * @returns {boolean}
     */
    isPending: function () {
        return this.get('status') === Shipment.STATUS_PENDING;
    },
    /**
     * @returns {boolean}
     */
    hasFailedAddressRegistration: function () {
        return this.get('status') === Shipment.STATUS_REGISTRATION_FAILED;
    },
    /**
     * @returns {boolean}
     */
    isReadyForPickup: function () {
        return this.get('status') === Shipment.STATUS_READY_FOR_PICKUP;
    },
    /**
     * @returns {boolean}
     */
    isShipped: function () {
        return this.get('shipmentTracking.status') === Shipment.STATUS_SHIPPED;
    },
    /**
     * @returns {boolean}
     */
    isDelivered: function () {
        return this.get('shipmentTracking.status') === Shipment.STATUS_DELIVERED;
    },
    /**
     * @returns {boolean}
     */
    hasBeenShipped: function () {
        return this.isShipped() || this.isDelivered();
    },
    /**
     * @returns {number}
     */
    getSellerId: function () {
        // TODO: This is probably not reliable if used outside of a transaction.
        return this.parents[0].get('seller').id;
    },
    getTransactionId: function () {
        // TODO: This is probably not reliable if used outside of a transaction.
        return this.parents[0].get('id');
    },

    /**
     * @returns {string}
     */
    getTrackingLabelURL: function () {
        return this.get('shipmentTracking.labelUrl');
    },

    /**
     * @returns {string}
     */
    getTrackingNumber: function () {
        return this.get('shipmentTracking.trackingNumber');
    },

    /**
     * @param {object} [passedOptions]
     * @param {string} [passedOptions.role=INTERNAL]
     * @param {string} [passedOptions.type=ADMIN]
     * @param {string} [passedOptions.level=INFO]
     * @param {string|number} [passedOptions.creatorId] Defaults to current user id
     * @param {string} [passedOptions.content] Defaults to empty string
     * @param {object[]} [passedOptions.anchors] Defaults to empty array
     * @returns {Note}
     */
    newNote: function (passedOptions) {
        var options = _.defaults(passedOptions, {
            anchors: [
                {
                    sourceId : this.getTransactionId(),
                    sourceType : Anchor.TYPE_TRANSACTION
                },
                {
                    sourceId: this.getSellerId(),
                    sourceType : Anchor.TYPE_SELLER
                },
                {
                    sourceId: this.id,
                    sourceType: Anchor.TYPE_SHIPMENT
                }
            ]
        });
        return this.get('notes').newNote(options);
    },
    /**
     * @param {object} noteOptions {@see Shipment#newNote}
     * @param {object} syncOptions Options for SoaModel.save
     * @returns {Deferred.promise}
     */
    addNewNote : function (noteOptions, syncOptions) {
        var note = this.newNote(noteOptions);
        this.get('notes').add(note);
        return note.save(null, syncOptions);
    },
    /**
     * Accept/Counter offer while saving shipment quote in one service call
     */
    dealerCompleteNegotiation: function (offer, counterOffer, passedOptions) {
        var options = _.extend({transitionFunction: 'updateAndTransition'}, passedOptions);
        return this.dealerTransitionWithOfferNote(
            Shipment.STATUS_PENDING, offer, counterOffer, options);
    },
    /**
     * Marks a shipment as SHIPPED. Optionally takes a note to create and anchor
     * @private
     * @param {object} [passedOptions]
     * @param {string} [passedOptions.noteContent] The content to insert into the note
     * @param {string} [passedOptions.noteRole] The note role
     * @param {string} [passedOptions.noteType] The note type
     * @returns {$.Deferred.promise}
     */
    _markShipped: function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            saveNoteFirst: true
        });
        return this.transitionWithNote(Shipment.STATUS_SHIPPED, options);
    },
    _updateShipmentAndAccountingQuote: function (accountingQuote, passedOptions) {
        var clump = new Clump();
        var options = _.defaults(passedOptions || {}, {
            saveNoteFirst: true,
            transitionFunction: 'update'
        });

        var quoteSave = accountingQuote.updateAccountingQuote(clump);
        var shipmentSave = this._clumpTransitionWithNote(clump, null, options);
        clump.run({ applyDynaParams: true });
        return $.when(quoteSave, shipmentSave);
    },
    /**
     * @param {TransactionShipmentQuote} accountingQuote
     * @param {object} passedOptions
     * @private
     * @returns {$.Deferred.promise}
     */
    _transitionShipmentAndAcceptAccountingQuote: function (accountingQuote, shipmentStatus, passedOptions) {
        var clump = new Clump();
        var options = _.defaults(passedOptions || {}, {
            saveNoteFirst: true,
            transitionFunction: 'updateAndTransition'
        });
        var quoteSave = accountingQuote.acceptAccountingQuote(clump);
        var shipmentSave = this._clumpTransitionWithNote(clump, shipmentStatus, options);
        clump.run({
            dynaOptions: {
                open: '___',
                close: '___',
                params: {
                    anchorId: {
                        clumpElement: "transition",
                        expression: "$.result.id"
                    }
                }
            }
        });
        return $.when(quoteSave, shipmentSave);
    },


    /**
     * asserts that the passed quote is actually an accounting quote and returns
     * passed options augmented with default values
     * @param accountingShipmentQuote
     * @param passedOptions
     * @returns {*}
     * @private
     */
    _getOptionsWithNoteDefaults: function (passedOptions) {
        return _.defaults(passedOptions || {}, {
            noteType: Note.TYPE_BUYER_SELLER,
            noteRole: Party.ROLE_INTERNAL,
            transitionFunction: 'updateAndTransition'
        });
    },

    _assertIsAccountingQuote: function(accountingShipmentQuote) {
        console.assert(accountingShipmentQuote instanceof TransactionShipmentQuote, 'accountingShipmentQuote must be instance of TransactionShipmentQuote');
        console.assert(accountingShipmentQuote.isAccountingQuote(), 'accountingShipmentQuote must an accounting quote');
    },
    /**
     * Use when a dealer marks a shipment as SHIPPED. Optionally create and anchor a note
     * @param passedOptions.noteContent The content to insert into the note
     * @returns {$.Deferred.promise}
     */
    markDealerShipped: function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            noteType: Note.TYPE_BUYER_SELLER,
            noteRole: Party.ROLE_SELLER,
            transitionFunction: 'updateAndTransition'
        });
        return this._markShipped(options);
    },
    markBuyerShipped: function () {
        return this.transition(Shipment.STATUS_SHIPPED);
    },
    /**
     * Use when a 1stdibs Admin marks a shipment as SHIPPED.
     * Marks the accountingShipmentQuote as 'ACCEPTED' as well.
     * Optionally create and anchor a note.
     * @param {TransactionShipmentQuote} accountingShipmentQuote The accounting shipment quote
     * @param {object} [passedOptions]
     * @param {string} [passedOptions.noteContent] The content to insert into the note
     * @returns {$.Deferred.promise}
     */
    mark1stdibsShipped: function (accountingShipmentQuote, passedOptions) {
        this._assertIsAccountingQuote(accountingShipmentQuote);
        var options = this._getOptionsWithNoteDefaults(passedOptions);
        return this._transitionShipmentAndAcceptAccountingQuote(accountingShipmentQuote, Shipment.STATUS_SHIPPED, options);
    },

    /**
     * Use when a dealer marks a shipment as SHIPPED and that
     * shipment was subsidized by 1stdibs.
     * Marks the accountingShipmentQuote as 'ACCEPTED' as well.
     * Optionally create and anchor a note.
     * @param {TransactionShipmentQuote} accountingShipmentQuote The accounting shipment quote
     * @param {object} [passedOptions]
     * @param {string} [passedOptions.noteContent] The content to insert into the note
     * @returns {$.Deferred.promise}
     */
    markDealerShipped1stdibsSubsidized: function (accountingShipmentQuote, passedOptions) {
        this._assertIsAccountingQuote(accountingShipmentQuote);
        var options = this._getOptionsWithNoteDefaults(_.extend({ noteRole: Party.ROLE_SELLER }, passedOptions));
        return this._transitionShipmentAndAcceptAccountingQuote(accountingShipmentQuote, Shipment.STATUS_SHIPPED, options);
    },
    overrideUpsLabel: function (accountingShipmentQuote, passedOptions) {
        passedOptions = passedOptions || { transitionFunction: 'update' };
        this._assertIsAccountingQuote(accountingShipmentQuote);
        var options = this._getOptionsWithNoteDefaults(passedOptions);
        return this._updateShipmentAndAccountingQuote(accountingShipmentQuote, options);
    },
    /**
     * Use when a 1stdibs Admin corrects shipping info after an address fails registration with easy post.
     * Marks the accountingShipmentQuote as 'ACCEPTED' and updates it as well.
     * Optionally create and anchor a note.
     * @param {TransactionShipmentQuote} accountingShipmentQuote The accounting shipment quote
     * @param {object} [passedOptions]
     * @param {string} [passedOptions.noteContent] The content to insert into the note
     * @returns {$.Deferred.promise}
     */
    enterShippingInfo: function (accountingShipmentQuote, passedOptions) {
        this._assertIsAccountingQuote(accountingShipmentQuote);
        var options = this._getOptionsWithNoteDefaults(passedOptions);
        return this._transitionShipmentAndAcceptAccountingQuote(accountingShipmentQuote, Shipment.STATUS_PENDING, options);
    },
    /**
     * Marks a shipment as READY_FOR_PICKUP. Optionally takes a note to create and anchor
     * @param passedOptions.noteContent The content to insert into the note
     * @param passedOptions.noteRole The note role
     * @param passedOptions.noteType The note type
     * @returns {$.Deferred.promise}
     */
    _markReadyForPickup: function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            saveNoteFirst: true
        });
        return this.transitionWithNote(Shipment.STATUS_READY_FOR_PICKUP, options);
    },
    /**
     * Use when a dealer marks a shipment as READY_FOR_PICKUP. Optionally create and anchor a note
     * @param passedOptions.noteContent The content to insert into the note
     *
     * @returns {$.Deferred.promise}
     */
    markDealerReadyForPickup: function (passedOptions) {
        var options;
        var noteType;

        if (this.isBuyerArrangedShipping()) {
            noteType = Note.TYPE_BUYER_SELLER;
        } else {
            noteType = Note.TYPE_SELLER_ADMIN;
        }

        options = _.defaults(passedOptions || {}, {
            noteType: noteType,
            noteRole: Party.ROLE_SELLER
        });
        return this._markReadyForPickup(options);
    },
    /**
     * Use when a 1stdibs Admin marks a shipment as DELIVERED. Optionally create and anchor a note
     * @param passedOptions.noteContent The content to insert into the note
     *
     * @returns {$.Deferred.promise}
     */
    mark1stdibsDelivered: function (passedOptions) {
        return this.transitionWithNote(Shipment.STATUS_DELIVERED, passedOptions);
    }
}, transitionMixin, periodMixin);



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/Shipment.js
// module id = 83
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54